import { render, staticRenderFns } from "./volUserApply.vue?vue&type=template&id=65e327b3&scoped=true"
import script from "./volUserApply.vue?vue&type=script&lang=js"
export * from "./volUserApply.vue?vue&type=script&lang=js"
import style0 from "./volUserApply.vue?vue&type=style&index=0&id=65e327b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e327b3",
  null
  
)

export default component.exports